(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    const getVisibleHeight = (selector) => {
    const node = document.querySelector(selector);
    if (!node) return 0;

    const styles = window.getComputedStyle(node);
    if (styles.display === 'none' || styles.visibility === 'hidden') return 0;

    const rect = node.getBoundingClientRect();
    if (rect.height <= 0) return 0;

    return Math.round(node.offsetHeight || rect.height || 0);
    };

    const syncTopBarsLayout = () => {
    const headerSection = document.querySelector('#shopify-section-header');
    if (!headerSection) return;

    const salesBannerHeight = getVisibleHeight('.sales-banner-section');
    const announcementBarHeight = getVisibleHeight('.announcement-bar-section');
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const totalOffset = isMobile ? salesBannerHeight : salesBannerHeight + announcementBarHeight;

    document.documentElement.style.setProperty('--sales-banner-height', `${salesBannerHeight}px`);
    headerSection.style.setProperty('margin-top', `${totalOffset}px`, 'important');

    // On mobile the announcement bar is fixed below the sticky header, so it overlaps
    // the page content. Push the main content down by the bar's measured height to clear it.
    const mainContent = document.querySelector('#MainContent');
    if (mainContent) {
    if (isMobile) {
    mainContent.style.setProperty('padding-top', `${announcementBarHeight}px`, 'important');
    } else {
    mainContent.style.removeProperty('padding-top');
    }
    }
    };

    window.syncTopBarsLayout = syncTopBarsLayout;

    class StickyHeader extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerInner = this.header ? this.header.querySelector('.header-wrapper') : null;
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.headerHeightMediaQuery = window.matchMedia('(max-width: 990px)');
    this.onHeaderHeightMediaChange = this.setHeaderHeight;

    this.setHeaderHeight();
    window.requestAnimationFrame(() => this.setHeaderHeight());
    window.addEventListener('load', this.setHeaderHeight);
    window.addEventListener('resize', this.setHeaderHeight);
    window.addEventListener('orientationchange', this.setHeaderHeight);

    // Web fonts can change the announcement-bar text wrapping (and therefore its
    // height) after the first measurement, so re-sync once they have loaded.
    if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => this.setHeaderHeight());
    }

    if (typeof this.headerHeightMediaQuery.addEventListener === 'function') {
    this.headerHeightMediaQuery.addEventListener('change', this.onHeaderHeightMediaChange);
    } else if (typeof this.headerHeightMediaQuery.addListener === 'function') {
    this.headerHeightMediaQuery.addListener(this.onHeaderHeightMediaChange);
    }

    if ('ResizeObserver' in window && this.headerInner) {
    this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
    this.headerResizeObserver.observe(this.headerInner);
    }

    // The announcement bar is fixed and its height drives the mobile content
    // offset, so re-sync whenever the bar (or sales banner) changes size.
    if ('ResizeObserver' in window) {
    this.topBarsResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
    ['.announcement-bar-section', '.sales-banner-section'].forEach((selector) => {
    const node = document.querySelector(selector);
    if (node) this.topBarsResizeObserver.observe(node);
    });
    }

    if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    }

    setHeaderHeight() {
    if (!this.header) return;

    const measuredNode = this.headerInner || this.header;
    const measuredHeight = Math.round(measuredNode.getBoundingClientRect().height || this.header.offsetHeight || 0);

    if (!measuredHeight) return;

    document.documentElement.style.setProperty('--header-height', `${measuredHeight}px`);
    if (typeof window.syncTopBarsLayout === 'function') {
    window.syncTopBarsLayout();
    }
    }

    disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('load', this.setHeaderHeight);
    window.removeEventListener('resize', this.setHeaderHeight);
    window.removeEventListener('orientationchange', this.setHeaderHeight);

    if (this.headerHeightMediaQuery) {
    if (typeof this.headerHeightMediaQuery.removeEventListener === 'function') {
    this.headerHeightMediaQuery.removeEventListener('change', this.onHeaderHeightMediaChange);
    } else if (typeof this.headerHeightMediaQuery.removeListener === 'function') {
    this.headerHeightMediaQuery.removeListener(this.onHeaderHeightMediaChange);
    }
    }

    if (this.headerResizeObserver) {
    this.headerResizeObserver.disconnect();
    }

    if (this.topBarsResizeObserver) {
    this.topBarsResizeObserver.disconnect();
    }
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }

    onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
    requestAnimationFrame(this.reveal.bind(this));
    } else {
    window.clearTimeout(this.isScrolling);

    this.isScrolling = setTimeout(() => {
    this.preventReveal = false;
    }, 66);

    requestAnimationFrame(this.hide.bind(this));
    }
    } else if (scrollTop <= this.headerBounds.top) {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    }

    hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    }

    reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);

    document.addEventListener('DOMContentLoaded', () => {
    const queueSyncTopBarsLayout = () => window.requestAnimationFrame(syncTopBarsLayout);

    syncTopBarsLayout();
    window.addEventListener('load', queueSyncTopBarsLayout);
    window.addEventListener('resize', queueSyncTopBarsLayout);
    window.addEventListener('orientationchange', queueSyncTopBarsLayout);

    if ('MutationObserver' in window) {
    const topSelectors = ['.announcement-bar-section', '.sales-banner-section'];

    topSelectors.forEach((selector) => {
    const node = document.querySelector(selector);
    if (!node) return;

    const observer = new MutationObserver(queueSyncTopBarsLayout);
    observer.observe(node, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
    });
    });
    }

    if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(queueSyncTopBarsLayout);
    ['.announcement-bar-section', '.sales-banner-section'].forEach((selector) => {
    const node = document.querySelector(selector);
    if (node) resizeObserver.observe(node);
    });
    }
    });
    
  } catch(e) { console.error(e); }
})();
})();
